<template>
  <div class="progress-wrap" :style="{height: height,backgroundColor:config.outputMatch.wrapColor}">
    <div
      class="progress-bar"
      :style="{
        height: height,lineHeight:height, width: `${num}%`,backgroundColor:config.outputMatch.barColor
      }"
    >
      <span :style="{'fontWeight':config.outputMatch.fontWeight,color:config.outputMatch.countColor}" v-if="visibleNum">{{ num }}{{ dw }}</span>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    config: {
      type: [Object, Array],
      default: () => {
        return {
          outputMatch: {
            barColor: '#007EFF',
            wrapColor: '#362D78'
          }
        }
      }
    },
    height: {
      type: String,
      default: '14px'
    },
    num: {
      type: [String, Number],
      default: 0
    },
    'visibleNum': {
      type: Boolean,
      default: true
    },
    dw: {
      default: '%'
    }
  },
  data () {
    return {}
  },
  computed: {},
  methods: {},
  created () {}
}
</script>

<style lang="stylus" scoped>
.progress-wrap
  font-size 12px
  color #fff
  background #362D78
  .progress-bar
    max-width 100%
    background #007EFF
    text-align center
    white-space nowrap
    > span
        display: inline-block
        height: 100%
        line-height: 14px !important
//   span
//     display inline-block
//     white-space normal
//     vertical-align middle
// .progress-bar:before
//   height 100%
//   display inline-block
//   vertical-align middle
//   content ''
</style>
